module.exports = __webpack_public_path__ + "static/media/si24-logo.cf5fff94.svg";